{
  "acerare": "legendary",
  "acespecrare": "legendary",
  "amazingrare": "legendary",
  "artrare": "epic",
  "blackwhiterare": "rare",
  "c": "common",
  "charactersuperrare": "epic",
  "classiccollection": "common",
  "codecard": "common",
  "common": "common",
  "commonholo": "common",
  "conceptrare": "epic",
  "destroyerangelrare": "epic",
  "destructionrare": "epic",
  "don": "common",
  "doublerare": "epic",
  "dragonballrare": "epic",
  "duopowerrare": "epic",
  "enchanted": "legendary",
  "epic": "epic",
  "expansionrare": "epic",
  "featurerare": "epic",
  "fixed": "common",
  "futuristicrare": "epic",
  "giantforcerare": "epic",
  "godrare": "epic",
  "holorare": "rare",
  "hyperrare": "legendary",
  "iconicattackrare": "epic",
  "ignoblevillainrare": "epic",
  "illustrationrare": "epic",
  "infinitesaiyanrare": "epic",
  "kagayaku": "legendary",
  "l": "common",
  "land": "common",
  "leader": "common",
  "legendary": "legendary",
  "m": "legendary",
  "megaattackrare": "epic",
  "megahyperrare": "legendary",
  "megaultrarare": "legendary",
  "merit": "common",
  "mythic": "legendary",
  "nobleherorare": "epic",
  "norarity": "common",
  "p": "common",
  "pikachurare": "epic",
  "pr": "common",
  "prismrare": "epic",
  "promo": "common",
  "quest": "common",
  "r": "rare",
  "radiantrare": "epic",
  "rainbowrare": "legendary",
  "rare": "rare",
  "rarebreak": "epic",
  "rarehololegend": "epic",
  "rarehololvx": "epic",
  "rebootleaderrare": "epic",
  "s": "legendary",
  "scr": "legendary",
  "secretrare": "legendary",
  "shining": "legendary",
  "shinyholorare": "epic",
  "shinyrare": "epic",
  "shinysecretrare": "legendary",
  "shinyultrarare": "legendary",
  "songohanrare": "epic",
  "special": "legendary",
  "specialartrare": "legendary",
  "specialillustrationrare": "legendary",
  "specialleaderrare": "epic",
  "specialrare": "epic",
  "specialraresignature": "legendary",
  "sr": "epic",
  "superrare": "epic",
  "superrareholo": "epic",
  "t": "common",
  "token": "common",
  "treasurerare": "legendary",
  "triplerare": "epic",
  "u": "rare",
  "uc": "rare",
  "ultrarare": "epic",
  "ultrararecommon": "epic",
  "ultrarareuncommon": "epic",
  "uncommon": "rare",
  "unconfirmed": "common"
}
